import React, { useState } from 'react'
import { Actuator, ActuatorButton } from '../../models/smart-home.model'
import ActuatorBase from '../base/ActuatorBase'
import { Box, CircularProgress } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { useActuatorUpdate } from '../../hooks/use-actuator-update'
import { J2Add, J2Subtract } from '@e3dc-react/icons'
import ActuatorButtonGroup from 'src/Libs/smart-home/components/base/ActuatorButtonGroup'

interface Props {
  serialNo: number
  actuator: Actuator
}

const Dimmer: React.FC<Props> = ({ serialNo, actuator }) => {
  const { t } = useCustomTranslation()
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const onUpdateActuator = useActuatorUpdate({ setIsLoading })

  const buttons: ActuatorButton[] = [
    {
      label: t('smart-home.actuator.dimmer.on').toUpperCase(),
      onClick: () => onUpdateActuator(serialNo, actuator, { command: 'on' }, 0),
      dataQa: 'button-dimmer-on',
    },
    {
      label: t('smart-home.actuator.dimmer.brighter').toUpperCase(),
      onClick: () => onUpdateActuator(serialNo, actuator, { command: 'brighter' }, 0),
      dataQa: 'button-dimmer-brighter',
      startIcon: <J2Add />,
      variant: 'outlined',
    },
    {
      label: t('smart-home.actuator.dimmer.darker').toUpperCase(),
      onClick: () => onUpdateActuator(serialNo, actuator, { command: 'darker' }, 0),
      dataQa: 'button-dimmer-darker',
      startIcon: <J2Subtract />,
      variant: 'outlined',
    },
    {
      label: t('smart-home.actuator.dimmer.off').toUpperCase(),
      onClick: () => onUpdateActuator(serialNo, actuator, { command: 'off' }, 0),
      dataQa: 'button-dimmer-off',
    },
  ]

  return (
    <ActuatorBase actuator={actuator} breakOnMobile>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
        {isLoading && <CircularProgress size={18} sx={{ top: '50%', left: '50%' }} />}
        <ActuatorButtonGroup buttons={buttons} />
      </Box>
    </ActuatorBase>
  )
}

export default Dimmer
